import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["switch", { checked: _ctx.modelValue, monocolor: _ctx.monocolor, disabled: _ctx.disabled }]),
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, _cache[1] || (_cache[1] = [
        _createElementVNode("span", { class: "slider round" }, null, -1)
    ]), 2));
}
